import Vue from 'vue';
import Component from 'vue-class-component';

import HeartIt from 'common/components/HeartIt';
import NewCarousel from 'components/NewCarousel';
import Rating from 'common/components/Rating';
import ActivityCarousel from 'components/ActivityCarousel';
import BaseProductReview from 'components/BaseProductReview';
import useBoxCatalogView from 'composables/useBoxCatalogView';
import {
  Marker,
  InfoWindow,
  CircleRadius,
} from 'common/components/Map/BbMap/Objects';
import BbMap from 'common/components/Map/BbMap';

import newWindow from 'ecommerce/assets/icons/NewWindow.svg';
import useKustomerBotHelpers from 'common/composables/kustomerBotHelpers';
import useIsMobile from 'common/composables/useIsMobile.js';
import expirationDateCompare from 'utils/expirationDateCompare';

@Component({
  components: {
    HeartIt,
    Rating,
    NewCarousel,
    ActivityCarousel,
    BaseProductReview,
    BbMap,
  },
  props: {
    activity: {
      type: Object,
      required: true,
    },
    isFriendsDay: {
      type: Boolean,
      default: false,
    },
    boxName: {
      type: String,
      required: true,
    },
    boxId: {
      type: String,
      required: true,
    },
    boxColour: {
      type: String,
      required: true,
    },
    goToExperienceTab: {
      type: Boolean,
      default: false,
    },
    isComparison: {
      type: Boolean,
      default: false,
    },
    gift: {
      type: Object,
      required: false,
    },
    booked: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { onToggleModalReservation, onActivityBySlug } = useBoxCatalogView();
    const { hideKustomer, showKustomer } = useKustomerBotHelpers();
    const { isMobile } = useIsMobile();

    return {
      toggleModalReservation: onToggleModalReservation,
      fetchActivityBySlug: onActivityBySlug,
      hideKustomer,
      showKustomer,
      isMobile,
    };
  },
})
export default class ExperiencePreviewComponent extends Vue {
  icons = {
    newWindow,
  };
  maxMobileResolution = 768;
  windowWidth = null;
  isMobile = null;
  mapClicked = false;
  currentTab = 'Summary';
  experienceTab = {
    name: 'GoToExperience',
    title:
      this.boxId === '47378'
        ? 'Reservá esta experiencia'
        : 'Ir a la experiencia',
  };
  infoWindow;
  comparisonActivityUrl = `/catalogo/${this.$route.params.hash}/${this.$route.params.boxSlug}/${this.activity.slug}/`;
  showReservationCta = false;

  get tabs() {
    const summaryTab = {
      name: 'Summary',
      title: 'Resumen',
    };

    const whatIncludesTab = {
      name: 'WhatIncludes',
      title: '¿Qué incluye?',
    };

    const mapTab = {
      name: 'Map',
      title: 'Mapa y Contacto',
    };

    const reviewsTab = {
      name: 'Reviews',
      title: `Opiniones (${this.activity.reviews_qty})`,
    };
    const goToExperienceTab =
      this.goToExperienceTab && !this.isMobile && !this.booked
        ? this.experienceTab
        : false;
    return [
      summaryTab,
      whatIncludesTab,
      !this.isOnlineActivity && mapTab,
      this.activity.reviews_qty > 0 && reviewsTab,
      goToExperienceTab,
    ].filter(Boolean);
  }

  get isOnlineActivity() {
    return this.activity.activity_type === 'online';
  }

  beforeMount() {
    this.recalculateWidth();
  }
  /**
   * Issue event to the parent component 'ExperienceBox' to close
   * the open preview, from the button at the top right.
   */

  created() {
    window.addEventListener('resize', this.recalculateWidth);
  }

  mounted() {
    if (this.gift && this.$route.name === 'box') {
      this.showReservationCta =this.gift.status === 'activated' && expirationDateCompare(this.gift.expiration_date)
      }
    if (this.isMobile) this.hideKustomer();
  }

  beforeDestroy() {
    if (this.isMobile) this.showKustomer();

    window.removeEventListener('resize', this.recalculateWidth);
  }

  get participantsIcon() {
    const amount = +this.activity.participants;
    if (amount === 1) {
      return '1Parcitipante';
    } else if (amount === 2) {
      return '2Participantes';
    } else if (amount > 2) {
      return 'MasParticipantes';
    }
    return null;
  }

  get isMultipleLocation (){
    return this.activity.locations.length > 1
  }

  recalculateWidth() {
    this.windowWidth = window.innerWidth;
    this.isMobile = this.windowWidth <= this.maxMobileResolution;
  }

  closePreviewBtn(activity) {
    this.$emit('closePreview', activity);
  }

  activityClicked() {
    const newRoute = {
      name: 'boxActivity',
      params: {
        categorySlug: this.$route.params.categorySlug,
        boxSlug: this.$route.params.boxSlug,
        activitySlug: this.activity.slug,
      },
    };
    let routeUrl = this.$router.resolve(newRoute).href;
    window.open(routeUrl, '_blank');
  }

  get experienceLocation() {
    if (this.activity.locations[0].delivery_in_all_country) {
      return 'Envío a todo el país';
    } else if (this.activity.activity_type === 'online') {
      return 'Formato online';
    }
    return `${this.activity.locations[0].sublocation} - ${this.activity.locations[0].address}`;
  }

  /**
   Create an array of activity objects for send props to BbMap, in case the activity have more than 1 activity
   * its going to create an object per location because BbMap needed. Yes its a negrada.
   * @returns {[]}
   */
  get parsedActivityLocations() {
    let locationsArray = [];

    if (this.activity) {
      this.infoWindow = new InfoWindow({
        component: 'BbGoogleMapDefaultInfoWindow',
      });
      locationsArray = this.activity.locations.map(location => {
        const marker = new Marker({
          id: location.id,
          position: { lat: location.latitude, lng: location.longitude },
          infoWindowContext: {
            ...this.activity,
            showName: true,
          },
        });
        if (
          this.activity.activity_type === 'delivery' &&
          location.delivery_radius
        ) {
          marker.circleRadius = new CircleRadius({
            radius: location.delivery_radius,
            center: { lat: location.latitude, lng: location.longitude },
          });
        }
        marker.settings.customMarker = false;
        return marker;
      });
    }
    return locationsArray;
  }

  get catalogReservationCtaText() {
    return this.activity.has_online_reservation
      ? 'Reservar esta actividad'
      : 'Reservar esta actividad';
  }

  async onGoToExperienceClick(condition, path) {
    if (!condition) {
      return;
    }
    return await this.$router.push(path).catch(() => {});
  }

  async openReservationModal() {
    await this.fetchActivityBySlug(this.activity.slug);
    this.toggleModalReservation();
  }

  changeTab(tab) {
    if (tab === 'GoToExperience') {
      this.onGoToExperienceClick(
        this.isFriendsDay,
        `${
          window.location.pathname.replace('-caja', '') + this.activity.slug
        }/`,
      );
      this.onGoToExperienceClick(this.isComparison, this.comparisonActivityUrl);
      this.onGoToExperienceClick(
        this.$route.params.hash || this.gift?.signed_code_id,
        {
          name: 'box-activity-catalog',
          params: {
            hash: this.showReservationCta
              ? this.gift.signed_code_id
              : this.$route.params.hash,
            boxSlug: this.$route.params.boxSlug,
            activitySlug: this.activity.slug,
          },
        },
      );
      return;
    }
    this.currentTab = tab;
  }

  onModalOpened(isOpened) {
    if (isOpened) {
      document.querySelector('.ExperienceBox.active').classList.add('opened');
      this.$emit('changePositionSelected', true);
    } else {
      document
        .querySelector('.ExperienceBox.active')
        .classList.remove('opened');
    }
  }
}
